import { render } from "./EditProjectDialog.vue?vue&type=template&id=25f63a43&scoped=true"
import script from "./EditProjectDialog.vue?vue&type=script&lang=js"
export * from "./EditProjectDialog.vue?vue&type=script&lang=js"

import "./EditProjectDialog.vue?vue&type=style&index=0&id=25f63a43&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f63a43"]])

export default __exports__